import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnblockUserRequest } from '../../interfaces/unblock-user.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class UnblockUserService {

  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url + '/cx/unblock_user'
  }
  unblockUser(token: string, nit: string, username: string): Observable<UnblockUserRequest> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  
    const body = {
      nit,
      username
    };
  
    return this.httpClient.post<UnblockUserRequest>(this.API_URL, body, { headers });
  }
}

